import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import adicionarFiltroItinerario from '../../actions/itinerario/adicionarFiltroItinerario'
import removerFiltroItinerario from '../../actions/itinerario/removerFiltroItinerario'
import listarFiltrosItinerario from '../../actions/itinerario/listarFiltrosItinerario'
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import FiltroBuscarItinerario from './FiltroBuscarItinerario';
import FiltroChaveValor from '../comum/FiltroChaveValor';
import {
  FILTRO_DATA_PARTIDA,
  FILTRO_HORA_PARTIDA_ITINERARIO,
  FILTRO_ASSENTOS,
  FILTRO_VEICULO,
  FILTRO_ROTA,
  FILTRO_PRESTADOR,
  FILTRO_TIPO_PRECO
} from '../../util/filtros'

export class FiltroItinerariosParaTransferencia extends Component {
  componentDidMount() {
    if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
      this.props.listarFiltrosItinerario(this.props.empresaSelecionada.id)
    }
  }

  componentDidUpdate(prevProps) {
    if (alterouEmpresa(this.props, prevProps)) {
      this.props.listarFiltrosItinerario(this.props.empresaSelecionada.id)
    }
  }


  adicionarFiltro(filtro) {
    this.props.adicionarFiltroItinerario(filtro)
  }

  removerFiltro(filtro) {
    this.props.removerFiltroItinerario(filtro)
  }

  render() {
    return (
      <React.Fragment>
        <div className="conteudo">

          <FiltroBuscarItinerario
            filtro={FILTRO_DATA_PARTIDA}
            opcoes={[new Date().getFullYear()]}
            isFiltroData={true}
          />
          <FiltroBuscarItinerario
            filtro={FILTRO_HORA_PARTIDA_ITINERARIO}
            opcoes={[]}
            isFiltroHora={true}
          />
          <FiltroBuscarItinerario
            filtro={FILTRO_ASSENTOS}
            opcoes={[]}
            isNumero={true}
          />
          <FiltroBuscarItinerario
            filtro={FILTRO_VEICULO}
            opcoes={[]}
            isNome={true}
          />
          <FiltroBuscarItinerario
            filtro={FILTRO_ROTA}
            opcoes={[]}
            isNome={true}
          />
          <FiltroBuscarItinerario
            filtro={FILTRO_PRESTADOR}
            opcoes={[]}
            isNome={true}
          />
          <FiltroChaveValor
            filtro={FILTRO_TIPO_PRECO}
            opcoes={this.props.tipoPrecos}
            filtrosAdicionados={this.props.filtrosAdicionados}
            adicionarFiltro={this.adicionarFiltro.bind(this)}
            removerFiltro={this.removerFiltro.bind(this)}
          />
        </div>
      </React.Fragment>
    )
  }
}

export const mapStateToProps = state => ({
  tipoConfiguracaoPreco: state.filtrosItinerarios.tipoConfiguracaoPreco,
  tipoAjuste: state.filtrosItinerarios.tipoAjuste,
  filtrosAdicionados: state.filtrosAdicionadosItinerario,
  empresaSelecionada: state.empresaSelecionada,
  tipoPrecos: state.filtrosItinerarios.tipoPrecos

})

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    adicionarFiltroItinerario,
    removerFiltroItinerario,
    listarFiltrosItinerario
  }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(FiltroItinerariosParaTransferencia)
